export default "__VITE_ASSET__aujauy0c__"